/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var bodybuilder = require('bodybuilder');
var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');
var toHash = require('common/util/toHash');
var _ = require('underscore');
var Constants = require('../../common/util/constants');

var StringCell = require('common/backgrid/StringCell');
var COCSelectRowCell = require('../../common/backgrid/COCSelectRowCell');

var ElasticSearchSummaryView = require('common/views/ElasticSearchSummaryView');

var SearchCOCEntities = require('../../internal-dashboard/services/SearchCOCEntities');

var tmplSearchForEntityModalView = require('../templates/COCSearchForEntityModalView.hbs');
require('../styles/COCSearchForEntityModalView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplSearchForEntityModalView,

  className: 'coc-search-for-entity-modal-view',

  ui: {
    searchSummary: '.search-summary',
    searchResultsContainer: '.search-results-container',
    search: '.search',
    submit: '.submit',
    noEntitySelected: '#noEntitySelected',
    formInputs: ':input'
  },

  regions: {
    searchResultsContainer: '@ui.searchResultsContainer',
    searchSummary: '@ui.searchSummary'
  },

  events: {
    'click @ui.search': 'onClickSearch',
    'click @ui.submit': 'onClickSubmit',
    'keydown @ui.formInputs': 'onKeydownOfInputs'
  },

  initialize: function() {
    this.lookupHashes = {
      entityTypes: toHash(this.model.get('entityTypes'), 'id', 'entityType'),
      organizationTypes: toHash(this.model.get('organizationTypes'), 'id', 'organizationType')
    };
    var searchEntityType = this.model.get('searchEntityType');
    var entityTypes = this.model.get('entityTypes');
    if (searchEntityType === Constants.VENUE) {
      entityTypes = _.filter(entityTypes, function(entityType) {
        return entityType.id === '1' || entityType.id === '3';
      });
      this.model.set('entityTypes', entityTypes);
    }
    if (searchEntityType === Constants.ORGANIZATION) {
      entityTypes = _.filter(entityTypes, function(entityType) {
        return entityType.id === '2' || entityType.id === '3';
      });
      this.model.set('entityTypes', entityTypes);
    }
  },

  onBeforeShow: function() {
    this.searchSummaryView = new ElasticSearchSummaryView({
      model: new Backbone.Model({
        searchLimit: this.model.get('searchLimit')
      })
    });
    this.showChildView('searchSummary', this.searchSummaryView);

    this.searchResults = new GridView({
      columns: [
        {
          name: 'isChecked',
          label: '',
          cell: COCSelectRowCell.SelectRowCell,
          headerCell: 'custom',
          width: 5,
          editable: true,
          sortable: false,
          singleSelect: true
        },
        {
          name: 'entityName',
          label: 'Entity Name',
          cell: StringCell,
          headerCell: 'custom',
          width: 20,
          editable: false
        },
        {
          name: 'fullAddress',
          label: 'Address',
          cell: StringCell,
          headerCell: 'custom',
          width: 25,
          editable: false
        },
        {
          name: 'entityType',
          label: 'Entity Type',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'organizationType',
          label: 'Organization Type',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'website',
          label: 'Website',
          cell: StringCell,
          headerCell: 'custom',
          width: 20,
          editable: false
        }
      ],
      collection: new PageableCollection([], { pageSize: 3 }),
      emptyText: 'No Entities Found'
    });
    this.showChildView('searchResultsContainer', this.searchResults);

    this.$('.backgrid.table').addClass('table-bordered');
  },

  onKeydownOfInputs: function(e) {
    // Searches on press of enter
    if (e.keyCode === 13) {
      this.onClickSearch(e);
    }
  },

  onClickSearch: function() {
    var self = this;
    var searchEntityType = this.model.get('searchEntityType');
    var data = Syphon.serialize(this, {
      inputReaders: Syphon.SearchInputReaderSet
    });

    // If no inputs were given, do not perform a search.
    if (
      !data.entityName &&
      !data.streetAddress &&
      !data.county &&
      !data.state &&
      !data.entityTypeId &&
      !data.organizationTypeId
    ) {
      return;
    }
    this.searchSummaryView.reset();

    var l = Ladda.create(this.ui.search[0]);
    l.start();
    var body = bodybuilder();

    if (data.entityName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'entityName', {
          query: data.entityName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'entityName', data.entityName.toLowerCase() + '*');
        b.orQuery('match', 'entityName.phonetic', data.entityName);
        return b;
      });
    }

    if (data.streetAddress) {
      body.query('bool', function(b) {
        b.orQuery('match', 'streetAddress', {
          query: data.streetAddress,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'streetAddress', data.streetAddress.toLowerCase() + '*');
        b.orQuery('match', 'streetAddress.phonetic', data.streetAddress);
        return b;
      });
    }

    if (data.state) {
      body.query('bool', function(b) {
        b.orQuery('match', 'state', {
          query: data.state,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'state', data.county.toLowerCase() + '*');
        b.orQuery('match', 'state.phonetic', data.state);
        return b;
      });
    }

    if (data.county) {
      body.query('bool', function(b) {
        b.orQuery('match', 'county', {
          query: data.county,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'county', data.county.toLowerCase() + '*');
        b.orQuery('match', 'county.phonetic', data.county);

        return b;
      });
    }

    if (data.entityTypeId) {
      body.query('term', 'entityTypeId', data.entityTypeId);
    }

    if (data.organizationTypeId) {
      body.query('term', 'organizationTypeId', data.organizationTypeId);
    }

    if (searchEntityType === Constants.VENUE) {
      body.query('bool', function(b) {
        b.orQuery('match', 'entityTypeId', '1');
        b.orQuery('match', 'entityTypeId', '3');
        return b;
      });
    }

    if (searchEntityType === Constants.ORGANIZATION) {
      body.query('bool', function(b) {
        b.orQuery('match', 'entityTypeId', '2');
        b.orQuery('match', 'entityTypeId', '3');
        return b;
      });
    }

    body.size(self.model.get('searchLimit'));
    var bodyObj = body.build();

    SearchCOCEntities(bodyObj, this.lookupHashes)
      .done(function(data) {
        l.stop();
        self.searchResults.collection.fullCollection.reset(data.hits);
        self.searchSummaryView.display(data);
      })
      .fail(function() {
        l.stop();
      });
  },

  onClickSubmit: function(e) {
    this.ui.noEntitySelected.hide();

    var selectedEntity = this.searchResults.collection.fullCollection.findWhere({
      isChecked: true
    });

    if (!selectedEntity) {
      this.ui.noEntitySelected.show();
      return;
    } else {
      this.ui.noEntitySelected.hide();

      this.triggerMethod('modal:close', selectedEntity);
    }
  }
});
